import { render, staticRenderFns } from "./PwaInstallAwardPopup.vue?vue&type=template&id=10bc2f7b&scoped=true&"
import script from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
export * from "./PwaInstallAwardPopup.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallAwardPopup.vue?vue&type=style&index=0&id=10bc2f7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc2f7b",
  null
  
)

export default component.exports